import { render, staticRenderFns } from "./historyclub.vue?vue&type=template&id=7278121f&"
import script from "./historyclub.vue?vue&type=script&lang=js&"
export * from "./historyclub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports